import {writable} from "svelte/store";

export const currentClient = writable<any>({});
